import {QualificheFornitore} from "@/types";

class QualificaManager {

    public stati = [
        {id: QualificheFornitore.DA_VERIFICARE, text: 'Da verificare'},
        {id: QualificheFornitore.NON_QUALIFICATO, text: 'Non qualificato'},
        {id: QualificheFornitore.QUALIFICATO, text: 'Qualificato'},
        {id: QualificheFornitore.SOSPESO, text: 'Sospeso'}
    ];

    qualifiche(config?: any) {
        return Promise.resolve({
            data: this.stati
        });
    }

    qualifica(id: number | string) {
        const el = this.stati.find(el=> el.id == id)
        return Promise.resolve({
            data: el
        });
    }

    list = this.qualifiche
    retrieve = this.qualifica
}

const qualificheManager = new QualificaManager()

export default qualificheManager
